enum StatusInutilizacaoNotaFiscal {
    Pendente = 0,
    Confirmado = 1,
    Reprovado = 2,
}

export default StatusInutilizacaoNotaFiscal;